import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import ButtonRow from '../../../Elements/ButtonRow';
import GeneralSearchStrip from '../../../Elements/GeneralSearchStrip';
import ApolloDataExportSearchParams from './ApolloDataExportSearchParams';
import ApolloDataExportService from '../../../Services/ApolloDataExportService';
import ApolloDataExportItem from '../../../Domain/ApolloDataExportItem';
import ApolloDataExportWindowDescription from './ApolloDataExportWindowDescription';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import Popup from '../../../Elements/popup';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ErrorMessage from '../../../Elements/ErrorMessage';

class ApolloDataExportAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      addressList: [],
      loading: true,
      selected: -1,
      selectedAddress: null,
      orderBy: 'Id',
      orderDirection: OrderDirectionsEnum.Asc,
      pageNumber: 1,
      numberOfElementsOnAPage: 20,
      numberOfElementsInTheTable: 0,
      shownPanel: ApolloDataExportSearchParams.isThereAnySearchParameter()
        ? ShownPanelsEnum.Search
        : ShownPanelsEnum.None,
      searchItem: new ApolloDataExportSearchParams(),
      popup: null,
    };
    this.showPanel = this.showPanel.bind(this);
    this.escFunction = this.escFunction.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.editPanelOnClose = this.editPanelOnClose.bind(this);
    ApolloDataExportItem.editFunction = this.clickOnEditIcon.bind(this);
    ApolloDataExportItem.startExportOnDemand = this.ClickOnStartImportManuallyButton.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
  }

  clickOnEditIcon(selectedId, selectedItem) {
    this.setState({
      selectedItem: selectedItem,
      shownPanel: ShownPanelsEnum.EditItem,
    });
  }

  startSearch(searchItem) {
    this.setState({
      loading: true,
      searchItem: searchItem,
    });
  }

  escFunction(event) {
    if (event.keyCode === 27) {
      this.setState({
        shownPanel: ShownPanelsEnum.None,
        selected: -1,
        selectedAddress: null,
      });
    }
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      this.refresh();
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: refresh,
    });
    if (refresh) {
      this.refresh();
    }
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.Search,
          <GeneralSearchStrip
            searchItem={this.state.searchItem}
            searchparamsType={ApolloDataExportSearchParams}
            isRefreshDisabled={false}
            isFilterDisabled={false}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnOk={(shownPanel, searchItem) => {
              this.setState({
                loading: true,
                searchItem: searchItem,
              });
            }}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new ApolloDataExportItem()}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={ApolloDataExportWindowDescription}
            errorCode='ADEA126'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.editPanelOnClose(false)}
            clickOnSave={() => this.editPanelOnClose(true)}
            windowDescription={ApolloDataExportWindowDescription}
            errorCode='ADEA134'
          />
        )}
      </div>
    );
  }

  refresh() {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
      loading: true,
      searchItem: { ...this.state.searchItem },
    });
  }

  renderSearchStrip() {
    return (
      <GeneralSearchStrip
        searchItem={this.state.searchItem}
        searchparamsType={ApolloDataExportSearchParams}
        isRefreshDisabled={false}
        isFilterDisabled={false}
        clickOnRefresh={this.refresh.bind(this)}
        clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
        clickOnOk={(shownPanel, searchItem) => {
          this.setState({
            loading: true,
            searchItem: { ...searchItem },
          });
        }}
      />
    );
  }
  renderButtonsAndPanels() {
    return (
      <>
        <ButtonRow
          labels={['Create']}
          colors={[ButtonColorsEnum.Primary]}
          keys={[ShownPanelsEnum.AddNewItem]}
          icons={['fa-solid fa-plus-circle']}
          roles={['User']}
          value={this.state.shownPanel}
          onClick={this.showPanel}
        />
        {this.renderPanels()}
      </>
    );
  }

  ClickOnStartImportManuallyButton(id) {
    this.setState({ loading: true });
    ApolloDataExportService.StartExportManually(id)
      .then((result) => {
        this.setState({
          popup: (
            <Popup
              text={result.data}
              cancelButtonText=''
              okButtonText='Ok'
              closePopupFunction={() => this.setState({ popup: null })}
              okPopupFunction={() => this.setState({ popup: null })}
            />
          ),
        });
        this.refresh();
      })
      .catch(() => ErrorMessage.SetErrorMessage('ADEA224'));
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderSearchStrip()}
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={ApolloDataExportItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={ApolloDataExportService.GetListBySearching}
          convertDBItemsFunction={ApolloDataExportService.ConvertDBItems}
          searchItem={this.state.searchItem}
          errorCode='ADEA196'
        />

        {this.state.popup}
      </div>
    );
  }
}

export default ApolloDataExportAdmin;
